(function () {
  'use strict';

  angular.module('sempraWebapp').component('operatingTimeIllumination', {
    templateUrl:
      'app/facilityKarcherDetails/operatingTimeIllumination/operatingTimeIllumination.html',
    controller: operatingTimeIllumination,
    bindings: {
      operatingTimeIlluminationList: '<',
      activation: '&',
      defaultVisibilityState: "<"
    },
    controllerAs: 'vm'
  });

  function operatingTimeIllumination(
    sortArrayService,
    helperService,
    $log,
    $mdDialog,
    karcherOperatingTimeDaysMapper
  ) {
    var vm = this;

    vm.$onInit = function () {
      vm.visibilityState = vm.defaultVisibilityState;
      vm.iconSource = !vm.visibilityState
        ? 'expand_less'
        : 'expand_more';
    };

    vm.$onChanges = function (changes) {
      if (
        changes.operatingTimeIlluminationList &&
        changes.operatingTimeIlluminationList.currentValue
      ) {
        vm.operatingTimeIlluminationList = sortArrayService.sortByGroupValue(
          karcherOperatingTimeDaysMapper.getDays(
            changes.operatingTimeIlluminationList.currentValue
          )
        );
      }
    };

    vm.hideContent = function () {
      vm.visibilityState = !vm.visibilityState;
      vm.iconSource = !vm.visibilityState
        ? 'expand_less'
        : 'expand_more';
    };

    vm.updateOperationIlluminationTime = function (ev, data) {
      if (!data) {
        return;
      }
      $mdDialog
        .show({
          controller: 'ActuateOperationTimeIlluminationController',
          controllerAs: 'vm',
          templateUrl:
            'app/karcherCustomDialogs/actuateOperationTimeIllumination/actuateOperationTimeIllumination.html',
          /* eslint-disable */
          parent: angular.element(document.body),
          /* eslint-enable */
          targetEvent: ev,
          locals: { data: data },
          clickOutsideToClose: false
        })
        .then(
          function (data) {
            vm.activation({ data: data.actuators, parentPointId: data.id });
          },
          function () {}
        );
    };
  }
})();
